import { createSlice } from "@reduxjs/toolkit";
import { MenuEnum } from "../../main/enums";

const initialState = {
  user: {},
  loading: false,
  error: null,
  menuActive: MenuEnum.All,
};

export const currentUserSlice = createSlice({
  name: "current_user",
  initialState,
  reducers: {
    currentUserCompleted: (state, action) => ({
      ...state,
      loading: false,
      user: action.payload,
      menuActive: action.payload.is_admin ? MenuEnum.All : MenuEnum.Own,
    }),
    changeMenuActive: (state, action) => ({
      ...state,
      menuActive: action.payload,
    }),
  },
});

export const { currentUserCompleted, changeMenuActive } =
  currentUserSlice.actions;
export default currentUserSlice.reducer;
